import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SessionTimeoutModal from './SessionTimeoutModal';

const SessionTimeoutMonitor = () => {
  const { 
    showSessionWarning, 
    sessionTimeRemaining: appTimeRemaining, 
    stayLoggedIn, 
    logout,
    warningType,
    expiringBrokerName,
    brokerSessionExpiry
  } = useAuth();

  let timeRemaining = appTimeRemaining;
  
  // If we are warning about a broker session, calculate its specific remaining time
  if (warningType === 'broker' && brokerSessionExpiry) {
      const now = Date.now();
      timeRemaining = Math.max(0, Math.floor((brokerSessionExpiry - now) / 1000));
  }

  return (
    <SessionTimeoutModal
      isOpen={showSessionWarning}
      timeRemaining={timeRemaining}
      onStayLoggedIn={stayLoggedIn}
      onLogout={logout}
      warningType={warningType}
      brokerName={expiringBrokerName}
    />
  );
};

export default SessionTimeoutMonitor;
